@if (isAuthorizeNetPayment()) {
    <a
        (click)="openAuthorizeNetTransactionDetails()"
        (keyup.enter)="openAuthorizeNetTransactionDetails()"
        tabindex="0"
        class="text-primary-800 cursor-pointer"
    >
        {{ paymentMessage }}
    </a>
} @else {
    <span>{{ paymentMessage }}</span>
}
